export const FIRST_TIME_DEP = 'ID76';
export const ONE_PLUS_DEPOSITOR = 'ID626';
export const FIRST_DEP = 'ID32';
export const SECOND_DEP = 'ID33';
export const THIRD_DEP = 'ID34';
export const FOURTH_DEP = 'ID35';
export const FIRST_CASHOUT = 'ID424';

export const VERIFIED = 'ID22V';
export const ALL_WELCOME_OFFERS_USED = 'ID36';
export const THREE_PACK_ALL_WELCOME_OFFERS_USED = 'ID625';
export const ALL_WELCOME_OFFERS_USED_FOR_STAG = 'ID87';
export const FIAT_MODE = 'DEVBIT384F';
export const CRYPTO_MODE = 'DEVBIT384C';

export const INSTALL_APP_GROUP = 'ID623';
export const INSTALL_APP_MISSION_BONUS_RECEIVED = 'ID622';

export const FIVE_DOLLAR_GROUP = 'ID624';

export const DEPOSIT_EXIT_BONUS_GROUP = 'ID794';

export const EXCLUDE_SEON_TEST_GROUP = 'ID29';

export const REFERRAL_GROUP = 'ID854';
